import type { JSX } from "solid-js"
import type { KnowledgeGlyphName } from "./knowledge-base-data"

// 领域字形全部手绘内联 SVG：不依赖图标库、不新增图片资源，
// 统一 24×24 viewBox + 1.6 描边 + currentColor 上色，方便按卡片主题色染色。
const GLYPHS: Record<KnowledgeGlyphName, () => JSX.Element> = {
  // 人工智能安全 —— 神经网络节点
  neural: () => (
    <>
      <circle cx="5.8" cy="6.4" r="2.2" />
      <circle cx="18.2" cy="6.4" r="2.2" />
      <circle cx="12" cy="17.8" r="2.2" />
      <circle cx="12" cy="10.9" r="1.7" />
      <path d="M7.5 7.9 10.6 10M16.5 7.9 13.4 10M12 12.6v3.2" />
    </>
  ),
  // 内容安全 —— 盾牌 + 勾
  shield: () => (
    <>
      <path d="M12 3.3 19 5.9v5.9c0 4.2-2.8 7.4-7 8.9-4.2-1.5-7-4.7-7-8.9V5.9l7-2.6Z" />
      <path d="M9.2 12.1l2 2 3.6-3.9" />
    </>
  ),
  // 智能体安全 —— 机器人头
  bot: () => (
    <>
      <rect x="4.4" y="8.6" width="15.2" height="10.4" rx="3" />
      <path d="M12 5.2v3.4" />
      <circle cx="12" cy="4.3" r="1.2" />
      <circle cx="9.3" cy="13.4" r="1.15" />
      <circle cx="14.7" cy="13.4" r="1.15" />
      <path d="M9.6 16.5h4.8" />
    </>
  ),
  // 数据与隐私 —— 挂锁
  lock: () => (
    <>
      <rect x="5" y="10.4" width="14" height="9.6" rx="2.6" />
      <path d="M8.3 10.4V8a3.7 3.7 0 0 1 7.4 0v2.4" />
      <circle cx="12" cy="15.1" r="1.2" />
      <path d="M12 16.3v1.5" />
    </>
  ),
  // 攻防对抗 —— 双向对冲箭头
  duel: () => (
    <>
      <path d="M3.6 12h7.2M8 8.5 11.5 12 8 15.5" />
      <path d="M20.4 12h-7.2M16 8.5 12.5 12 16 15.5" />
    </>
  ),
  // 鉴伪与取证 —— 指纹
  fingerprint: () => (
    <>
      <path d="M12 5.4c-3.6 0-6.5 2.9-6.5 6.4 0 1.5.3 2.7.9 3.9" />
      <path d="M12 5.4c3.6 0 6.5 2.9 6.5 6.4 0 3-1.1 5.6-2.2 7" />
      <path d="M12 8.2c-2 0-3.6 1.6-3.6 3.6 0 2.4.7 4.2 1.6 5.7" />
      <path d="M12 8.2c2 0 3.6 1.6 3.6 3.6 0 3-.6 5.6-1.4 7.2" />
      <path d="M12 11.1c-.6 0-1.1.5-1.1 1.1 0 3-.4 5.5-1 7.1" />
    </>
  ),
  // 威胁情报 —— 雷达扫描
  radar: () => (
    <>
      <path d="M12 4.1a7.9 7.9 0 1 1-6.2 12.8" />
      <circle cx="12" cy="12" r="3.6" />
      <path d="M12 12l5.6-5.6" />
      <circle cx="15.5" cy="8.5" r="1.2" />
    </>
  ),
  // 治理与合规 —— 天平
  scale: () => (
    <>
      <path d="M12 4.4v15.2" />
      <path d="M8.4 19.6h7.2" />
      <path d="M4.6 8h14.8" />
      <path d="M7.5 8 4.5 13.9h6L7.5 8Z" />
      <path d="M16.5 8l-3 5.9h6L16.5 8Z" />
    </>
  ),
}

export function KnowledgeGlyph(props: { name: KnowledgeGlyphName; class?: string }) {
  return (
    <svg
      class={props.class}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      {GLYPHS[props.name]()}
    </svg>
  )
}
